<!-- Shepherd.js will handle the tour UI, so we only need a minimal container -->
<div class="shepherd-tour-container">
  <!-- The tour is now managed by Shepherd.js in the component TypeScript -->
</div>